module.exports = __webpack_public_path__ + "static/insurance-16865f63f4c8817ed39daa303fa3b456.jpg";